export class KnowledgeLevelData {
    private knowledgeLevelList: string[] = ['Extensive', 'Good', 'Limited'];
    public getKnowledgeLevelList(): Array<string> {
        return this.knowledgeLevelList;
    }
}
